import {
  resolveNotificationTarget,
  type NotificationLinkSource,
  type NotificationScreen,
  type NotificationTarget,
} from '@repo/types'

// Map each abstract notification screen to an admin (react-router) route. The
// Record is EXHAUSTIVE over NotificationScreen — adding a screen to the shared
// union (@repo/types) breaks this build until it is routed here, so admin and
// mobile can never silently drift. `null` = no destination.
const ROUTES: Record<NotificationScreen, (t: NotificationTarget) => string | null> = {
  contact: (t) => (t.id ? `/crm/contacts/${t.id}` : '/crm/contacts'),
  deal: (t) => (t.id ? `/crm/deals/${t.id}` : null),
  viewing: (t) => (t.id ? `/calendar?event=${t.id}` : '/calendar'),
  // Denny digest („Zajtra: N udalosti") — kalendar otvoreny na danom dni.
  calendarDay: (t) => (t.date ? `/calendar?date=${t.date}` : '/calendar'),
  task: () => '/tasks',
  // Denny digest („Po termine: N uloh") — admin nema detail ulohy, zoznam je cielom vzdy.
  taskList: () => '/tasks',
  property: (t) => (t.id ? `/properties/${t.id}/edit` : '/properties'),
  // Zmeškaný hovor nemá vlastný detail v admine — zoznam osôb, kde číslo nájde hľadanie.
  callLog: () => '/crm/contacts',
  // Admin has a monitor list only (no per-listing detail page).
  monitor: () => '/monitor',
  lawyerRequest: (t) => (t.id ? `/legal-requests/${t.id}` : '/legal-requests'),
  importJob: () => '/imports',
  // EmailsPage opens the message via the ?messageId= deep-link (selects account too).
  email: (t) => (t.id ? `/emails?messageId=${t.id}` : '/emails'),
  // Úprava fotky (AI) — formulár nehnuteľnosti otvorí editor danej fotky s výsledkom.
  photoEdit: (t) => (t.propertyId ? `/properties/${t.propertyId}/edit${t.id ? `?photoEdit=${t.id}` : ''}` : null),
}

export function notificationDeepLink(n: NotificationLinkSource): string | null {
  const target = resolveNotificationTarget(n)
  return target ? ROUTES[target.screen](target) : null
}
